// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import Checkbox from '../../components/Checkbox'

class FilterCheckbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterOptions: [],
      filterLoaded: false,
    }

    this.watchFilterOptionsStore = this.watchFilterOptionsStore.bind(this);
  }

  componentDidMount() {
    this.watchFilterOptionsStore()
  }

  watchFilterOptionsStore() {
    window.store.FilterOptions.watch(state => {
      const { options, loading } = state;

      const filterName = this.props.filterName

      this.setState({
        filterOptions: options[filterName] || [],
        filterLoaded: !loading
      })
    })
  }
  
  render() {
    const { filterOptions } = this.state
    const { activeItems, handleUpdateFilter, filterName, title } = this.props

    return ( 
      <div className="advanced-filter__checkbox-section checkbox-section">
        <h4 className="advanced-filter__section-title">
          {title}
        </h4>
        <ul className="checkbox-section__fields-list">
          { filterOptions.length > 0 && filterOptions.map((filterOption, index) => (
            <li
              key={`${filterOption.title}-${index}`}
              className="checkbox-section__field"
            >
              <Checkbox
                name={filterOption.title}
                labelText={filterOption.title}
                handleChange={(event) => handleUpdateFilter(filterName, event.target.value)}
                checked={activeItems.includes(filterOption.title)}
                value={filterOption.title}
              />
            </li>
           )
          )}
        </ul>
      </div>
    );
  }
}

FilterCheckbox.defaultProps = {
  activeItems: [],
  handleUpdateFilter: () => {},
  filterName: '',
  title: '',
};

FilterCheckbox.propTypes = {
  activeItems: PropTypes.arrayOf(),
  handleUpdateFilter: PropTypes.func,
  filterName: PropTypes.string,
  filterName: PropTypes.string,
};

export default FilterCheckbox;
